const accountType = Object.freeze({
  rothIra: 'ROTH_IRA',
  traditionalIra: 'TRADITIONAL_IRA',
  individual: 'INDIVIDUAL',
  jointRightsOfSurvivorship: 'JOINT_RIGHTS_OF_SURVIVORSHIP',
  jointByEntirety: 'JOINT_BY_ENTIRETY',
  jointInCommon: 'JOINT_IN_COMMON',
  jointCommunityProperty: 'JOINT_COMMUNITY_PROPERTY',
  joint: 'JOINT',
  type401k: 'TYPE_401K',
  corporate: 'CORPORATE',
  coverdell: 'COVERDELL',
  trust: 'TRUST',
  sepIra: 'SEP_IRA',
  simpleIra: 'SIMPLE_IRA',
  traditionalIraInherited: 'TRADITIONAL_IRA_INHERITED',
  rothIraInherited: 'ROTH_IRA_INHERITED',
  rolloverIra: 'ROLLOVER_IRA',
  estate: 'ESTATE',
  other: 'OTHER',
  ugmaUtma: 'UGMA_UTMA',
  entityPartnership: 'ENTITY_PARTNERSHIP',
  entityNonProfit: 'ENTITY_NON_PROFIT',
  entityInvestmentClub: 'ENTITY_INVESTMENT_CLUB',
  entitySoleProprietor: 'ENTITY_SOLE_PROPRIETOR',
  entityLlc: 'ENTITY_LLC',
  planProfitSharing: 'PLAN_PROFIT_SHARING',
  planMoneyPurchance: 'PLAN_MONEY_PURCHASE',
  planDefinedBenefit: 'PLAN_DEFINED_BENEFIT',
  planNonQualified: 'PLAN_NON_QUALIFIED',
  omnibus: 'OMNIBUS',
  type403b: 'TYPE_403B',
  deliveryVersusPayment: 'DELIVERY_VERSUS_PAYMENT',
  simpleIraInherited: 'SIMPLE_IRA_INHERITED',
  rolloverIraInherited: 'ROLLOVER_IRA_INHERITED',
  planProfitSharingInherited: 'PLAN_PROFIT_SHARING_INHERITED',
  planMoneyPurchaseInherited: 'PLAN_MONEY_PURCHASE_INHERITED',
  escheatment: 'ESCHEATMENT',
  subAccount: 'SUB_ACCOUNT',
  primeBroker: 'PRIME_BROKER',
  rothIraMinor: 'ROTH_IRA_MINOR',
  traditionalIraMinor: 'TRADITIONAL_IRA_MINOR',
  sepIraInheritied: 'SEP_IRA_INHERITED',
});

export default accountType;
